/*
 * Project: BookingEngine
 * Module: Transfers.js
 * @flow
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setLanguage } from 'redux-i18n';

type Props = {
  params: any;
}

class Transfers extends React.Component {
  props: Props

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    if (!this.props.user || !this.props.checkin) {
      this.setWidget = false;
    } else {
      this.setWidget = true;
      this.props.dispatch(setLanguage(this.props.lang));
    }
  }

  addWidget() {
    const {
      user, config, locator, dropoff, pickup, occupancy,
    } = this.props;
    const { checkin, checkout, lang } = this.props;

    const data = document.createElement('script');
    data.type = 'text/javascript';
    data.setAttribute('data-widget', 'true');
    data.setAttribute('data-userid', user);
    data.setAttribute('data-config', config);
    data.setAttribute('data-reference', locator);
    data.setAttribute('data-datefrom', this.dateFormat(checkin));
    data.setAttribute('data-dateto', this.dateFormat(checkout));
    data.setAttribute('data-adults', occupancy.adults);
    data.setAttribute('data-children', occupancy.children);
    data.setAttribute('data-ages', occupancy.ages.join(','));
    data.setAttribute('data-language', lang);
    data.setAttribute('data-dropoff', dropoff);
    data.setAttribute('data-pickup', pickup);
    data.src = '//wdgmul.hotelbeds.com/wdgfront/generator/widget.js';
    // eslint-disable-next-line react/no-string-refs
    const container = this.refs.WidgetContent;
    container.appendChild(data);
  }

  componentDidMount() {
    if (this.setWidget) {
      this.addWidget();
    }
  }

  dateFormat(date) {
    return date ? date.replace(/-/g, '') : '';
  }

  render() {
    return (
      // eslint-disable-next-line react/no-string-refs
      <div ref="WidgetContent" />
    );
  }
}

Transfers.propTypes = {
  pickup: PropTypes.string,
  dropoff: PropTypes.string,
  user: PropTypes.string,
  config: PropTypes.string,
  locator: PropTypes.string,
  lang: PropTypes.string,
  checkin: PropTypes.string,
  checkout: PropTypes.string,
  occupancy: PropTypes.object,
};

Transfers.contextTypes = {
};

export default connect()(Transfers);
